export default "__VITE_ASSET__CFLYbgzE__"